"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserTimezone = exports.getIntervalLabel = exports.getIntervalFromNowWithMs = exports.getIntervalFromNow = exports.formatISO = exports.formatDateWithGMT = exports.formatDateLegacy = exports.formatDateWithSeconds = exports.formatDate = exports.localeUses24HourTime = exports.FIFTY_NINE_SECONDS = exports.ZERO_SECONDS = exports.FORMAT_UTC = exports.FORMAT_AMPM_WITH_SECONDS = exports.FORMAT_24H_WITH_SECONDS = exports.FORMAT_AMPM = exports.FORMAT_24H = void 0;
var date_fns_1 = require("date-fns");
var moment_1 = __importDefault(require("moment"));
var date_fns_tz_1 = require("date-fns-tz");
var i18next_1 = __importDefault(require("i18next"));
exports.FORMAT_24H = 'dd MMM yyyy HH:mm';
exports.FORMAT_AMPM = 'dd MMM yyyy hh:mm aa';
exports.FORMAT_24H_WITH_SECONDS = 'dd MMM yyyy HH:mm:ss';
exports.FORMAT_AMPM_WITH_SECONDS = 'dd MMM yyyy hh:mm:ss aa';
exports.FORMAT_UTC = "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'";
exports.ZERO_SECONDS = { seconds: 0, milliseconds: 0 };
exports.FIFTY_NINE_SECONDS = { seconds: 59, milliseconds: 999 };
// Workaround for guessing the locale from the browser
function localeUses24HourTime() {
    var locale = Intl.DateTimeFormat().resolvedOptions().locale;
    var dateTimeFormat = new Intl.DateTimeFormat(locale, { hour: 'numeric' });
    var formatted = dateTimeFormat.format(new Date());
    return !formatted.match(/am|pm/i);
}
exports.localeUses24HourTime = localeUses24HourTime;
var formatDate = function (date) {
    var formatToApply = localeUses24HourTime() ? exports.FORMAT_24H : exports.FORMAT_AMPM;
    return (0, date_fns_1.format)(date, formatToApply);
};
exports.formatDate = formatDate;
var formatDateWithSeconds = function (date) {
    var formatToApply = localeUses24HourTime() ? exports.FORMAT_24H_WITH_SECONDS : exports.FORMAT_AMPM_WITH_SECONDS;
    return (0, date_fns_1.format)(date, formatToApply);
};
exports.formatDateWithSeconds = formatDateWithSeconds;
/**
 * Old format function to be ported to date-fns
 */
var formatDateLegacy = function (date) {
    var format = 'DD/MM/YYYY  HH:mm:ss';
    var momentDate = (0, moment_1.default)(date);
    var utcOffset = (0, moment_1.default)().utcOffset() / 60;
    var timeZone = "GMT".concat(utcOffset > 0 ? "+".concat(utcOffset) : utcOffset);
    var timestampFormatted = momentDate.format(format);
    return { timestampFormatted: timestampFormatted, timeZone: timeZone };
};
exports.formatDateLegacy = formatDateLegacy;
var formatDateWithGMT = function (date) {
    var formatString = 'dd/MM/yyyy  HH:mm:ss';
    var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    var zonedDate = (0, date_fns_tz_1.utcToZonedTime)(date, timeZone);
    var timestampFormatted = (0, date_fns_tz_1.format)(zonedDate, formatString, { timeZone: timeZone });
    var offset = -new Date().getTimezoneOffset() / 60;
    var formattedTimeZone = "GMT".concat(offset >= 0 ? "+".concat(offset) : offset);
    return { timestampFormatted: timestampFormatted, formattedTimeZone: formattedTimeZone };
};
exports.formatDateWithGMT = formatDateWithGMT;
var formatISO = function (date) {
    return (0, date_fns_1.format)(date, exports.FORMAT_UTC);
};
exports.formatISO = formatISO;
var getIntervalFromNow = function (date) {
    var _a = (0, date_fns_1.intervalToDuration)({ start: date, end: new Date() }), years = _a.years, months = _a.months, days = _a.days, hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
    return ([
        { timeNum: years || 0, timeUnit: 'year' },
        { timeNum: months || 0, timeUnit: 'month' },
        { timeNum: days || 0, timeUnit: 'day' },
        { timeNum: hours || 0, timeUnit: 'hour' },
        { timeNum: minutes || 0, timeUnit: 'minute' },
        { timeNum: seconds || 0, timeUnit: 'second' },
    ].find(function (el) { return el.timeNum > 0; }) || { timeNum: 0, timeUnit: 'second' });
};
exports.getIntervalFromNow = getIntervalFromNow;
/**
 * Compute the number of years, months, days, hours, minutes, seconds,milliseconds since the decision was taken
 */
function getIntervalFromNowWithMs(date, now) {
    if (now === void 0) { now = new Date(); }
    var delta = Math.abs(now.getTime() - date.getTime());
    var milliseconds = delta % 1000;
    delta = (delta - milliseconds) / 1000; // convert to seconds
    var seconds = delta % 60;
    delta = (delta - seconds) / 60; // convert to minutes
    var minutes = delta % 60;
    delta = (delta - minutes) / 60; // convert to hours
    var hours = delta % 24;
    var days = (delta - hours) / 24; // convert to days
    return { days: days, hours: hours, minutes: minutes, seconds: seconds, milliseconds: milliseconds };
}
exports.getIntervalFromNowWithMs = getIntervalFromNowWithMs;
var getIntervalLabel = function (date, isDisplaySeconds) {
    if (isDisplaySeconds === void 0) { isDisplaySeconds = false; }
    if (new Date().getTime() - date.getTime() < 60000 && !isDisplaySeconds) {
        return i18next_1.default.t('ITEM.MODERATION_NOTES.A_MOMENT_AGO');
    }
    return (0, date_fns_1.formatDistanceToNowStrict)(date, { addSuffix: true });
};
exports.getIntervalLabel = getIntervalLabel;
var getUserTimezone = function () {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
};
exports.getUserTimezone = getUserTimezone;
